import { 
  createRouteRef, 
  createSubRouteRef 
} from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';
import { EpDevPManageAppsApiRoutesFactory } from '@solace-labs/backstage-plugin-ep-devp-manage-apps-common';

const PluginId = EpDevPPluginIds.EpDevPManageAppsPluginId;

export const rootRouteRef = createRouteRef({
  id: `${PluginId}:route:root`,
});

export const listManageAppsRouteRef = createSubRouteRef({
  id: `${PluginId}:route:list`,
  parent: rootRouteRef,
  path: '/:organizationId',
});
EpDevPManageAppsApiRoutesFactory.validateRoute({
  pluginId: PluginId,
  actualRoute: listManageAppsRouteRef.path,
  expectedRoute: EpDevPManageAppsApiRoutesFactory.getSubRouteList()
});

export const viewManageAppRouteRef = createSubRouteRef({
  id: `${PluginId}:route:view`,
  parent: rootRouteRef,
  path: '/:organizationId/:domainId/:assetId/*'
});
EpDevPManageAppsApiRoutesFactory.validateRoute({
  pluginId: PluginId,
  actualRoute: viewManageAppRouteRef.path,
  expectedRoute: `${EpDevPManageAppsApiRoutesFactory.getSubRouteDomainById()}/*`
});
